function formatPhoneNumber(value: string) {
  // Returns phone number in the format (123)456-7890
  // Appends 1 if passed in
  // TODO: how to format international numbers with more than 11 digits

  if (!value) return;

  const cleaned = ('' + value).replace(/\D/g, '');
  let match;

  if (cleaned.length === 7) {
    match = cleaned.match(/^(\d{3})(\d{4})$/);
    if (match) return `${match[1]}-${match[2]}`;
  } else if (cleaned.length === 9) {
    match = cleaned.match(/^(\d{3})(\d{3})(\d{3})$/);
    if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
  } else if (cleaned.length === 10) {
    match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
  } else if (cleaned.length > 10 && cleaned.length <= 13) {
    const countryLen = cleaned.length - 10;
    const re = new RegExp(`^(\\d{${countryLen}})(\\d{3})(\\d{3})(\\d{4})$`);
    match = cleaned.match(re);
    if (match) {
      return `${match[1]}(${match[2]}) ${match[3]}-${match[4]}`;
    }
  }

  return value;
}

export { formatPhoneNumber };
